module.exports = __webpack_public_path__ + "img/intro.23c3e53c.png";